<template>
  <div
    class="custom-input"
    :class="{
      'custom-input--placeholder-no-active': isNoActivePlaceholder,
      'custom-input--icon': isIcon,
    }"
  >
    <input
      class="custom-input__text"
      :type="type"
      :placeholder="isNoActivePlaceholder ? placeholder : ' '"
      :value="modelValue"
      @input="changeInput"
    />
    <label
      v-if="!isNoActivePlaceholder && !isError"
      class="custom-input__placeholder"
      >{{ placeholder }}</label
    >
    <div class="custom-input__icons-container" v-if="isIcon">
      <div class="custom-input__shown"></div>
      <slot name="icon"></slot>
    </div>
  </div>
</template>
<script setup>
  const props = defineProps({
    type: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    modelValue: {
      type: String,
    },
    isError: {
      type: Boolean,
    },
    isNoActivePlaceholder: {
      type: Boolean,
    },
    isIcon: {
      type: Boolean,
    },
  });

  const emit = defineEmits(["update:modelValue"]);

  const changeInput = (e) => {
    emit("update:modelValue", e.target.value);
  };
</script>
<style lang="scss">
  .custom-input {
    position: relative;
    overflow: hidden;

    &.custom-input--icon {
      .custom-input__text {
        padding: 8px 40px 8px 16px;
      }
    }

    &--placeholder-no-active {
      .custom-input__text {
        padding: 8px 16px;
      }
    }

    .custom-input__text:not(:placeholder-shown)
      ~ .custom-input__placeholder:not(.custom-input__placeholder--no-active),
    .custom-input__text:focus
      ~ .custom-input__placeholder:not(.custom-input__placeholder--no-active) {
      font-size: 14px;
      top: 16px;
      transition: all 0.3s ease-in-out;
    }

    &--disabled {
      .custom-input__placeholder {
        // color: rgba($gray1, 0.4);
      }
    }

    &__btn {
      position: absolute;
      right: 16px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
    }

    &__text {
      display: block;
      overflow: overlay;
      padding: 25px 16px 6px 16px;
      height: 54px;
      width: 100%;
      border-radius: 4px;
      background: $lightGray;
      font-family: $FFCircle;
      font-size: 15px;
      font-weight: 400;
      line-height: normal;

    }

    &__placeholder {
      pointer-events: none;
      position: absolute;
      left: 16px;
      top: 50%;
      transform: translateY(-50%);
      color: $darkGray;
      font-size: 16px;
      font-weight: 500;
      line-height: normal;
      z-index: 2;
      transition: all 0.3s ease-in-out;

      &--error {
        display: none;
      }

      &--active {
        font-size: 14px;
        top: 16px;
        transition: all 0.3s ease-in-out;
      }
    }

    &__clear {
      cursor: pointer;
      position: relative;
      right: 0px;
      top: 0px;
      width: 100%;
      height: 100%;
      max-height: 54px;
      background-color: transparent;
      z-index: 2;

      &::after {
        content: "";
        position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        right: 16px;
        top: 16px;
        width: 16px;
        height: 16px;
        border-radius: 100%;
        box-shadow: 3px 0px 15px 0px rgba(117, 117, 117, 0.05);
        // background-image: url("/assets/images/clear_input.svg");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 8px;
        background-color: #c3c8cc;
      }
    }

    &__error {
      bottom: 0;
      position: absolute;
      color: $redTxt;
      font-size: 12px;
      font-weight: 400;
      line-height: normal;
    }

    &__items {
      max-height: 276px;
      overflow: auto;

      &--select-store {
        max-height: 326px;
      }
    }

    &__list {
      width: 100%;
      position: absolute;
      border-top: 1px solid #dcdcdc;
      background-color: $white;
      z-index: 5;
      padding-top: 8px;
    }

    &__item {
      cursor: pointer;
      position: relative;
      padding: 8px;
      transition: all 0.3s ease-in-out;

      @media (hover: hover) and (pointer: fine) {
        &:hover {
          border-radius: 4px;
          background: #f5f7f9;
          transition: all 0.3s ease-in-out;
        }
      }

      &::before {
        content: "";
        position: absolute;
        width: calc(100% - 16px);
        height: 1px;
        left: 8px;
        bottom: 0;
        background-color: #f5f7f9;
      }

      &-city {
        color: #65676e;
        font-size: 14px;
        font-weight: 400;
      }

      &-time {
        color: #65676e;
        font-size: 14px;
        font-weight: 400;
        margin-right: 24px;
      }

      &-distance {
        display: flex;
        color: #65676e;
        font-size: 14px;
        font-weight: 400;

        img {
          margin-right: 8px;
          width: 16px;
          height: 16px;
        }
      }

      &-up {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 2px;
        transition: all 0.3s ease-in-out;

        span {
          font-weight: 700;
        }

        @media (hover: hover) and (pointer: fine) {
          &:hover {
            // color: $primary2Contrast;
            transition: all 0.3s ease-in-out;
          }
        }
      }

      &-down {
        display: flex;
      }
    }

    &__icons {
      &-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        width: 36px;
        background-color: transparent;
      }
    }

    @include table {
      &__text {
        font-size: 16px;

        &:focus {
          font-size: 16px;
        }
      }

      &__list {
        left: 0;
        width: 100%;
      }

      &__items {
        max-height: 100%;
      }

      &__item {
        padding-left: 10px;
        padding-right: 10px;
      }
    }
  }
</style>
